<div class="list-card-flag">
  <span class="list-card-flag__text">
    <ng-content></ng-content>
  </span>
</div>
